<div class="sections">
  <div class="card header-card">
    <div class="card-header display-flex billing-header">
      <div class="flex-start gap-3">
        <h5 class="mb-0">
          Monthly Bill
        </h5>
      </div>
      <div class="flex-gap billing-actions">
        <label class="font-bold" for="azureBillingMonth">Month</label>
        <input
          id="azureBillingMonth"
          autocomplete="off"
          class="datetimepicker form-control month-input"
          type="text"
        />
        <button class="btn btn-primary-soft" (click)="load()" [disabled]="loading">
          Refresh
        </button>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body flow-auto">
      <div class="alert alert-danger" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <table class="table table-docs table-hover">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Subscription Id</th>
            <th>Cost</th>
          </tr>
        </thead>
        <tbody *ngIf="rows.length > 0">
          <tr *ngFor="let row of rows; let i = index">
            <td>{{ i + 1 }}</td>
            <td>
              <span class="nav-link p-0" (click)="openResourceGroups(row)">
                {{ row.subscription_id }}
              </span>
            </td>
            <td>${{ (+row.total_amount || 0).toFixed(2) }}</td>
          </tr>
        </tbody>
        <tbody *ngIf="!loading && rows.length === 0">
          <tr>
            <td colspan="3" class="center">No data found</td>
          </tr>
        </tbody>
        <tbody *ngIf="loading">
          <tr>
            <td colspan="3" class="center">
              <img src="../assets/img/loading_2.svg" alt="loading" class="width-18" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
